var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"font-size-10 text-muted",domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('div',{staticClass:"font-size-14"},[_vm._v(_vm._s(_vm.value)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.unit)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }